import { makeStyles } from '@material-ui/core/styles';

const styles = theme => ({
  downloadContainer: {
    [theme.breakpoints.down('sm')]: {
      padding: '60px 0'
    }
  },
  featuredImageContainer: {
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse',
    }
  },
  limitedWidth: {
    maxWidth: 1024
  },
  phone: {
    width: '120%',
    marginLeft: '-10%'
  },
  subtitleText: {
    color: '#9f9f9f'
  },
  textMe: {
    [theme.breakpoints.down('sm')]: {
      marginTop: 20,
      width: '100%'
    }
  },
})

export default makeStyles(styles)
